<div class="modal-header">
  <h5 class="modal-title">🧾 Generate Collection</h5>
  <button type="button" class="btn-close" aria-label="Close" (click)="close()"></button>
</div>

<div class="modal-body">
  <form (ngSubmit)="generate()" novalidate>
    <!-- Location Dropdown -->
    <div class="mb-3">
      <label for="location" class="form-label">Select Location:</label>
     <select
        id="location"
        class="form-select"
        [(ngModel)]="selectedLocationId"
        name="location"
        required
        (change)="onLocationChange()"
>

       <option value="" disabled>Select a location</option>
        <option *ngFor="let loc of locations" [value]="loc.id">
          {{ loc.locationName }}
        </option>
      </select>
    </div>

    <!-- Previous Collection Date -->
    <div class="mb-3">
      <label for="previousDate" class="form-label">Previous Collection Date:</label>
      <input
        type="date"
        class="form-control"
        id="previousDate"
        [(ngModel)]="previousDate"
        name="previousDate"
        required
      />

    </div>

    <!-- Split Percentage -->
    <div class="mb-3">
      <label for="splitPercentage" class="form-label">Split Percentage (0 - 1):</label>
      <input
        type="number"
        class="form-control"
        id="splitPercentage"
        [(ngModel)]="splitPercentage"
        name="splitPercentage"
        step="0.01"
        min="0"
        max="1"
      />
    </div>


<div class="form-check mb-3">
<input
  class="form-check-input"
  type="checkbox"
  id="useMeters"
  [(ngModel)]="useMechanicalMeters"
  name="useMechanicalMeters"
  (change)="onMetersToggle()"
>

  <label class="form-check-label" for="useMeters">
    Use mechanical meters (requires previous snapshots)
  </label>
</div>

<!-- Context banner + jump to grid -->
<div *ngIf="useMechanicalMeters" class="alert alert-warning py-2 d-flex align-items-center justify-content-between">
  <div>
    <ng-container *ngIf="!hasAnyPrev; else hasPrevMsg">
      No previous snapshots found for this location. Enter the <b>Prev</b> meters below,
      then click <b>Save selected as Previous</b>.
    </ng-container>
    <ng-template #hasPrevMsg>
      Previous snapshots were auto-filled. Enter <b>Current</b> meters and click
      <b>Save selected as Current</b>.
    </ng-template>
  </div>
<button
  type="button"
  class="btn btn-sm btn-outline-secondary ms-3"
  (click)="scrollToMetersGrid()"
  [disabled]="!useMechanicalMeters"
>
  Jump to meters
</button>

</div>
<!-- Anchor for smooth scroll -->
<!-- Anchor for the Jump button sits right above the grid -->
<div #metersGridTop *ngIf="useMechanicalMeters"></div>

<div *ngIf="useMechanicalMeters" class="mt-3 border rounded p-3">
  <div class="d-flex flex-wrap align-items-end gap-2 mb-2">
    <div>
      <label class="form-label mb-1">Previous snapshot time</label>
      <input class="form-control" type="text" [value]="previousDate + 'T00:00:00'" disabled>
    </div>

    <div>
      <label class="form-label mb-1">Current reading time</label>
      <input class="form-control" type="datetime-local"
             [(ngModel)]="currReadingTime"
             name="currReadingTime"
             (change)="applyTimeToAll(currReadingTime)">
    </div>

    <div class="ms-auto">
      <button type="button" class="btn btn-outline-secondary" (click)="loadMetersGrid()">
        Refresh meters
      </button>
    </div>
  </div>

<div class="table-responsive meter-grid">
  <table class="table table-bordered align-middle">
    <colgroup>
      <col style="width:110px"><!-- Use -->
      <col><!-- Asset Tag -->
      <col><!-- Game -->
      <col><!-- Serial -->
      <col><!-- Prev In -->
      <col><!-- Prev Out -->
      <col><!-- Prev Time -->
  <col class="w-curr"><!-- Curr In -->
  <col class="w-curr"><!-- Curr Out -->
  <col class="w-time"><!-- Curr Time -->
      <col><!-- Δ In -->
      <col><!-- Δ Out -->
    </colgroup>

    <thead class="table-light">
      <tr>
        <th>Use</th>
        <th>Asset Tag</th>
        <th>Game</th>
        <th>Serial Number</th>
        <th class="text-end">Prev In</th>
        <th class="text-end">Prev Out</th>
        <th>Prev Time</th>
        <th class="text-end">Curr In</th>
        <th class="text-end">Curr Out</th>
        <th>Curr Time</th>
        <th class="text-end">Δ In</th>
        <th class="text-end">Δ Out</th>
      </tr>
    </thead>

    <tbody>
      <tr *ngFor="let r of meterRows; index as i">
        <td class="text-center">
          <input type="checkbox" [(ngModel)]="r.use" name="use{{i}}">
        </td>
        <td>{{ r.assetTag }}</td>
        <td>{{ r.gameName || '—' }}</td>
        <td>{{ r.serialNumber || '—' }}</td>

        <td class="text-end">{{ r.prevIn ?? 0 }}</td>
        <td class="text-end">{{ r.prevOut ?? 0 }}</td>
        <td>{{ r.prevTime || (previousDate + 'T00:00:00') }}</td>

<td>
  <input
    class="form-control meter-num text-end"
    type="number" min="0" step="1" inputmode="numeric"
    (wheel)="$event.preventDefault()"
    [(ngModel)]="r.currIn" name="currIn{{i}}"
    [style.width.%]="100"
    [style.minWidth.px]="120"
  >
</td>
<td>
  <input
    class="form-control meter-num text-end"
    type="number" min="0" step="1" inputmode="numeric"
    (wheel)="$event.preventDefault()"
    [(ngModel)]="r.currOut" name="currOut{{i}}"
    [style.width.%]="100"
    [style.minWidth.px]="120"
  >
</td>

        <td>
          <input class="form-control meter-time"
                 type="datetime-local"
                 [(ngModel)]="r.readingTime" name="readingTime{{i}}">
        </td>

        <td class="text-end">{{ meterDelta(r.currIn, r.prevIn) | number:'1.0-0' }}</td>
        <td class="text-end">{{ meterDelta(r.currOut, r.prevOut) | number:'1.0-0' }}</td>
      </tr>
    </tbody>
  </table>
</div>


  <div class="d-flex gap-2 justify-content-end">
    <button type="button" class="btn btn-outline-primary"
            (click)="saveAllMeters('previous')">
      Save selected as Previous
    </button>
    <button type="button" class="btn btn-primary"
            (click)="saveAllMeters('current')">
      Save selected as Current
    </button>
  </div>
</div>




    <!-- Manual Game Entries -->
<!-- Add Manual Game Button -->
<div class="mb-3">
  <button
    type="button"
    class="btn btn-outline-secondary w-100"
    (click)="showManualGameSection = !showManualGameSection"
  >
    <i class="mdi mdi-plus-circle-outline me-1"></i>
    {{ showManualGameSection ? 'Hide Manual Games' : 'Add Manual Game' }}
  </button>
</div>

<!-- Manual Game Entry Section -->
    <div *ngIf="showManualGameSection" class="mb-4 border rounded p-3 bg-light">
      <label class="form-label fw-semibold">Manual Game Entries:</label>
      
      <div
        *ngFor="let game of manualGames; let i = index"
        class="mb-3 border p-3 rounded bg-white shadow-sm"
      >
        <div class="row">
          <div class="col-md-4 mb-2">
            <label class="form-label">Game Name</label>
            <input
              type="text"
              class="form-control"
              [(ngModel)]="game.gameName"
              name="gameName{{ i }}"
              required
            />
          </div>
          <div class="col-md-4 mb-2">
            <label class="form-label">Cash In</label>
            <input
              type="number"
              class="form-control"
              [(ngModel)]="game.cashIn"
              name="cashIn{{ i }}"
              min="0"
              step="0.01"
            />
          </div>
          <div class="col-md-4 mb-2">
            <label class="form-label">Cash Out</label>
            <input
              type="number"
              class="form-control"
              [(ngModel)]="game.cashOut"
              name="cashOut{{ i }}"
              min="0"
              step="0.01"
            />
          </div>
        </div>
        <div class="text-end">
          <button
            type="button"
            class="btn btn-danger btn-sm"
            (click)="removeManualGame(i)"
            *ngIf="manualGames.length > 1"
          >
            <i class="mdi mdi-delete-outline"></i> Remove
          </button>
        </div>
      </div>

      <div class="text-end">
        <button
          type="button"
          class="btn btn-outline-primary"
          (click)="addManualGame()"
        >
          <i class="mdi mdi-plus"></i> Add Another Game
        </button>
      </div>
    </div>



    <!-- Error Message -->
    <div *ngIf="errorMessage" class="alert alert-danger py-2">
      {{ errorMessage }}
    </div>

    <!-- Submit Button -->
    <button class="btn btn-primary w-100" type="submit" [disabled]="isLoading">
      <i class="mdi mdi-cash me-1"></i>
      {{ isLoading ? 'Generating...' : 'Generate Collection' }}
    </button>
  </form>

  <!-- Collection Result Display -->
  <div *ngIf="collectionSummary" id="collection-summary" class="mt-4 border-top pt-3">
    <h6 class="fw-semibold mb-3">📊 Collection Summary</h6>

    <ul class="list-group mb-3">
      <li class="list-group-item"><strong>Location:</strong> {{ collectionSummary.locationName }}</li>
      <li class="list-group-item"><strong>Previous Date:</strong> {{ collectionSummary.previousDate | date }}</li>
      <li class="list-group-item"><strong>Current Date:</strong> {{ collectionSummary.currentDate | date }}</li>
      <li class="list-group-item"><strong>Total Cash In:</strong> {{ collectionSummary.totalCashIn | currency }}</li>
      <li class="list-group-item"><strong>Total Cash Out:</strong> {{ collectionSummary.totalCashOut | currency }}</li>
      <li class="list-group-item"><strong>Gross:</strong> {{ collectionSummary.totalGross | currency }}</li>
      <li class="list-group-item"><strong>Split:</strong> {{ collectionSummary.splitPercentage * 100 }}%</li>
      <li class="list-group-item"><strong>Collector Share:</strong> {{ collectionSummary.collectorShare | currency }}</li>
    </ul>

    <!-- Game Summary Table -->
    <div class="table-responsive">
      <table class="table table-bordered table-sm">
        <thead class="table-light">
          <tr>
            <th>Game</th>
            <th>Cash In</th>
            <th>Cash Out</th>
            <th>Gross</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let game of collectionSummary.gameSummaries">
            <td>{{ game.gameName }}</td>
            <td>{{ game.cashInDelta | currency }}</td>
            <td>{{ game.cashOutDelta | currency }}</td>
            <td>{{ game.gross | currency }}</td>
          </tr>
          <!-- Total row -->
          <tr class="table-dark fw-semibold">
            <td>Total</td>
            <td>{{ collectionSummary.totalCashIn | currency }}</td>
            <td>{{ collectionSummary.totalCashOut | currency }}</td>
            <td>{{ collectionSummary.totalGross | currency }}</td>
          </tr>
        </tbody>
      </table>
    </div>

    <!-- Download PDF -->
  <div class="text-end mt-3">
    <button class="btn btn-outline-secondary" (click)="exportToPDF()">
      <i class="mdi mdi-download me-1"></i> Download PDF
    </button>
  </div>
  </div>
</div>

<!-- Nested modal content for recording meters -->
<ng-template #meterTpl let-modal>
  <div class="modal-header">
    <h6 class="modal-title">Record mechanical meters</h6>
    <button type="button" class="btn-close" aria-label="Close" (click)="modal.dismiss()"></button>
  </div>

  <div class="modal-body">
    <div class="mb-2">
   <label class="form-label">Board (Asset Tag)</label>
<select class="form-select"
        [(ngModel)]="meterBoardId"
        name="meterBoardId"
        required
        (change)="applyPrevToForm(meterBoardId)">
  <option value="" disabled>Select a board</option>
  <option *ngFor="let b of boardsAtLocation" [value]="b.id">
    {{ b.assetTag }}&nbsp;• {{b.serialNumber}}<span *ngIf="b.gameName">&nbsp;• {{ b.gameName }}</span>
  </option>
</select>
    </div>
  </div>
  <div>
    <div class="row">
      <div class="col-6 mb-2">
        <label class="form-label">Meter In</label>
        <input type="number" class="form-control" [(ngModel)]="meterIn" name="meterIn" min="0" step="1">
      </div>
      <div class="col-6 mb-2">
        <label class="form-label">Meter Out</label>
        <input type="number" class="form-control" [(ngModel)]="meterOut" name="meterOut" min="0" step="1">
      </div>
    </div>

    <div class="mb-2">
      <label class="form-label">Reading Time</label>
      <input type="datetime-local" class="form-control" [(ngModel)]="meterReadingTime" name="meterReadingTime">
    </div>
  </div>

<div class="modal-footer">
  <button class="btn btn-secondary" (click)="modal.dismiss()">Cancel</button>
  <button class="btn btn-outline-primary"
          (click)="saveMetersAs('previous', modal)"
          [disabled]="!meterBoardId || meterIn==null || meterOut==null">
    Save as Previous
  </button>
  <button class="btn btn-primary"
          (click)="saveMetersAs('current', modal)"
          [disabled]="!meterBoardId || meterIn==null || meterOut==null">
    Save as Current
  </button>
</div>

</ng-template>

